import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deletePhoto } from '../api/deletePhoto';

type Props = {
    onSuccess: () => void;
};

export const useDeletePhoto = ({ onSuccess }: Props) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deletePhoto,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['userPhoto'] });
            onSuccess();
        },
    });
};
